function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgPackage = function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M17.343 8.926a.753.753 0 01-.014.007l-4.579 2.29V21.55l7.806-3.903a1.25 1.25 0 00.694-1.118v-9.53-.026l-3.907 1.953zM8.683 3.26L17 7.421l3.318-1.66-7.762-3.88a1.25 1.25 0 00-1.11-.001L8.681 3.26zM7.004 4.1L3.682 5.761 12 9.921l3.323-1.662L7.005 4.1zm-.412-1.47a.753.753 0 01.147-.074L10.776.537a2.75 2.75 0 012.448 0l8 4A2.75 2.75 0 0122.75 7v9.53a2.75 2.75 0 01-1.525 2.46l-8 4a2.75 2.75 0 01-2.46 0l-8.002-4a2.748 2.748 0 01-1.513-2.47v-9.52a2.75 2.75 0 011.525-2.46l3.818-1.91zm4.657 18.925V11.222l-8.5-4.25v9.552a1.25 1.25 0 00.685 1.124l7.815 3.907z"
  }));
};

SvgPackage.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgPackage.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgPackage;